import fetch from "auth/FetchInterceptor";

const productEndpointPrefix = "/product";
const productsService = {};

productsService.getAllProducts = async () =>
	await fetch(`${productEndpointPrefix}/getAllForAdminSchool`, {
		method: "GET",
	});

productsService.getOneProductForAdminSchool = async ({ id }) =>
	await fetch(`${productEndpointPrefix}/getOneProductForAdminSchool/${id}`);

productsService.createProduct = async ({ product }) =>
	await fetch(`${productEndpointPrefix}/create`, {
		method: "POST",
		data: product,
		timeout: 1000000,
	});
productsService.updateProduct = async ({ product, id }) =>
	await fetch(`${productEndpointPrefix}/update/${id}`, {
		method: "PUT",
		data: product,
		timeout: 1000000,
	});

productsService.deleteProductById = async ({ id }) =>
	await fetch(`${productEndpointPrefix}/deleteById/${id}`, {
		method: "DELETE",
	});

export default productsService;
